import AccessibleIcon from "@mui/icons-material/Accessible";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import ChargerIcon from "@mui/icons-material/ChargingStation";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Chip, Stack, Tooltip } from "@mui/material";
import { amber, green, lightBlue, red } from "@mui/material/colors";
import React from "react";
export function BoxFeatures(props) {
    const { features, renderEmpty, minimized, labels, } = props;
    if (renderEmpty && features.length == 0) {
        return React.createElement("span", null, labels("None"));
    }
    return (React.createElement(Stack, { direction: "row", spacing: 1 }, features.sort().map(feature => (React.createElement(FlagChip, { key: feature, label: labels(feature), color: COLORS[feature], Icon: ICONS[feature], minimized: minimized })))));
}
const COLORS = {
    Accessible: amber[800],
    Cooled: lightBlue[400],
    DangerousGoods: red[400],
    Charger: green[400],
};
const ICONS = {
    Accessible: AccessibleIcon,
    Cooled: AcUnitIcon,
    DangerousGoods: WarningAmberIcon,
    Charger: ChargerIcon,
};
function FlagChip({ label, color, Icon, minimized }) {
    return (React.createElement(Tooltip, { title: minimized ? label : "", placement: "top" },
        React.createElement(Chip, { sx: {
                borderColor: color,
                color,
                "&.MuiChip-root .MuiChip-icon": {
                    color,
                },
                "&.MuiChip-root .MuiChip-label": {
                    paddingLeft: minimized ? 0 : undefined,
                },
            }, variant: "outlined", icon: React.createElement(Icon, null), label: !minimized ? label : undefined })));
}
//# sourceMappingURL=BoxFeatures.js.map